import { FC } from "react";

interface BodyColumnPropType {
  label: string;
  width?: any;
  color?: string;
  alignLabel?: "text-left" | "text-center" | "text-right";
}

const BodyColumn: FC<BodyColumnPropType> = ({
  label,
  width,
  color,
  alignLabel,
}) => {
  return (
    <td width={width}>
      <div
        className={
          "base-body-column" + (alignLabel ? ` ${alignLabel}` : " text-left")
        }
      >
        <span
          className="column-text"
          style={{
            maxWidth: width ? `calc(${width} - 10px)` : "unset",
            color: color ? color : "#475467",
          }}
          title={label}
        >
          {label}
        </span>
      </div>
    </td>
  );
};

export default BodyColumn;
